export enum Month {
  JANUARY = 'Январь',
  FEBRUARY = 'Февраль',
  MARCH = 'Март',
  APRIL = 'Апрель',
  MAY = 'Май',
  JUNE = 'Июнь',
  JULY = 'Июль',
  AUGUST = 'Август',
  SEPTEMBER = 'Сентябрь',
  OCTOBER = 'Октябрь',
  NOVEMBER = 'Ноябрь',
  DECEMBER = 'Декабрь',
}
